import React, { Component } from 'react';
import { Link } from 'react-router';
import PublicModal from '../components/PublicModal.js';
import ProgressButton from '../components/ProgressButton.js';
import PasswordInput from '../components/PasswordInput.js';

import api from '../utils/api';

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: this.props.params && this.props.params.resetToken,
      password: '',
      confirmPassword: '',

      resetting: false,
      errorResetting: false,
      reset: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.renderContents = this.renderContents.bind(this);
    this.formValid = this.formValid.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const { value, name } = target;

    // Update the state key of the input's `name` with the new value.
    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ resetting: true, errorResetting: null });
    const { token, password } = this.state;

    const payload = {
      token,
      newPassword: password
    };

    api('/reset-password', {
      method: 'POST',
      body: JSON.stringify(payload)
    }).then((res) => {
      this.setState({ resetting: false, reset: true })
    }).catch((err) => {
      console.error(`Couldn't reset password:`, err);
      this.setState({ resetting: false, errorResetting: err });
    });
  }

  formValid() {
    const { password, confirmPassword } = this.state;
    if (password && confirmPassword) {
      // Require password and confirmPassword to match, as well as
      // be greater than or equal to 7 characters.
      if (password === confirmPassword) {
        return password.length >= 7;
      }
    }

    return false;
  }

  renderContents() {
    if (this.state.reset) {
      return (
        <div>
          <h1>Success!</h1>
          <p>We've gone ahead and reset your password. Feel free to <a href="https://normcore.io/dashboard">log in with your new credentials</a>.</p>
        </div>
      )
    }

    let helpText = <p>Use the form below to set yourself a new password.</p>;

    if (this.state.errorResetting) {
      helpText = <p>Hmm, we couldn't process your reset. Reason: {this.state.errorResetting.description}</p>;
    }

    return (
      <div>
        <h1>Reset your password</h1>
        {helpText}

        <form className="form LoginForm" disabled={this.state.resetting} action="#" onSubmit={this.handleSubmit}>
          <PasswordInput
            inputClassName="form-input form-input--dark form-input--fullwidth"
            name="password"
            placeholder="password"
            onChange={this.handleInputChange}
            disabled={this.state.resetting}
            value={this.state.password} />

          <div className="form-group">
            <input className="form-input form-input--dark form-input--fullwidth"
              name="confirmPassword"
              type="password"
              placeholder="confirm password"
              onChange={this.handleInputChange}
              disabled={this.state.resetting}
              value={this.state.confirmPassword} />
          </div>

          <ProgressButton type="submit"
            buttonStyle="dark"
            formSubmit={true}
            label="Submit"
            loadingLabel="Submitting..."
            loading={this.state.resetting}
            disabled={!this.formValid() || this.state.resetting} />
        </form>
      </div>
    );
  }

  render() {
    return (
      <div className="ForgotPasswordPage">
        <PublicModal centered={false}>
          <div className="col-md-8 col-md-push-2">
            {this.renderContents()}
          </div>
        </PublicModal>
      </div>
    );
  }
}

export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordPage.js